/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { ICustomMarkerLoaderService } from './custom-marker-loader.service.interface';

@Injectable({
  providedIn: 'root'
})
export class CustomMarkerLoaderService implements ICustomMarkerLoaderService {
  load(): Observable<any> {
    const sub = new BehaviorSubject(null);
    import('../../components/google-maps/scripts/custom-marker')
      .then(module => {
        sub.next(module.CustomMarker);
      })
      .catch(err => {});

    return sub.asObservable();
  }
}
